import React from 'react';

import { withSavedReports } from '../../../shared/containers/containerSavedReports'
import { withFilterSavedReports } from '../../../shared/containers/containerFilterSavedReports'

import Pagination from '../../../shared/items/contols/pagination'

const SavedReportsPaginationWrapper = props => {
  const { onHandleChangeSavedReportsFilter, filterSavedReportsCount, filterSavedReportsPage, savedReportsTotal } = props

  return filterSavedReportsCount < savedReportsTotal
    ? <Pagination
      totalCount={savedReportsTotal}
      count={filterSavedReportsCount}
      page={filterSavedReportsPage}
      onHandleChangeStore={onHandleChangeSavedReportsFilter.bind(this)}
    />
    : null
}

export default withSavedReports(withFilterSavedReports(React.memo(SavedReportsPaginationWrapper)))


